import { GeoLocationDetails } from '@brenger/api-client';

export const isValidAddress = (address: GeoLocationDetails['address']): boolean => {
  return Boolean(
    address.administrative_area && address.country_code && address.country_name && address.latitude && address.longitude
  );
};
